import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import ProjectPage from "@/pages/ProjectPage";
import ConsolidationPage from "@/pages/ConsolidationPage";
import UsersPage from "@/pages/UsersPage";
import PropertiesPage from "@/pages/PropertiesPage";
import OverviewPage from "@/pages/OverviewPage";
import RateShopperPage from "@/pages/RateShopperPage";
import TeamPage from "@/pages/TeamPage";

const Protected = ({ children, perm, roles }) => {
  const { user, can } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500" data-testid="auth-loading">
        Loading session...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (perm && !can(perm)) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/projects/:id" element={<Protected><ProjectPage /></Protected>} />
            <Route path="/overview" element={<Protected><OverviewPage /></Protected>} />
            <Route path="/rate-shopper" element={<Protected><RateShopperPage /></Protected>} />
            <Route path="/consolidation" element={<Protected perm="consolidation"><ConsolidationPage /></Protected>} />
            <Route path="/admin/users" element={<Protected perm="manage_users"><UsersPage /></Protected>} />
            <Route path="/admin/properties" element={<Protected perm="manage_users"><PropertiesPage /></Protected>} />
            <Route path="/team" element={<Protected roles={["general_manager", "super_admin"]}><TeamPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
